module.exports = __webpack_public_path__ + "media/images/badge/supporter-96bc10f7e6431dc8961c52b3b2823554.png";